/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import "../../styles/Bars/TopBar/Topbar.style.css";
import NavItem from "../../components/Bars/NavItem.component";

// import all icons
import { ReactComponent as DashboardIm } from "../../assets/Icons/Topbar/Dashboard.svg";
import { ReactComponent as StructureIm } from "../../assets/Icons/Topbar/Structure.svg";
import { ReactComponent as PersonGroupIm } from "../../assets/Icons/Topbar/Person-Group.svg";
import { ReactComponent as ActivitiesIm } from "../../assets/Icons/Topbar/Activities.svg";

import { ReactComponent as AttendanceIm } from "../../assets/Icons/Topbar/Academic/Attendance.svg";
import { ReactComponent as StudentsIm } from "../../assets/Icons/Topbar/Academic/Students.svg";
import { ReactComponent as TeachersIm } from "../../assets/Icons/Topbar/Academic/Teachers.svg";
import { ReactComponent as ExamsIm } from "../../assets/Icons/Topbar/Academic/Exams.svg";
import { ReactComponent as EventsIm } from "../../assets/Icons/Topbar/Academic/Events.svg";
import { ReactComponent as ProgramsIm } from "../../assets/Icons/Topbar/Academic/ProgramsIcon.svg";
import { ReactComponent as AdmissionIm } from "../../assets/Icons/Topbar/Academic/Admission.svg";

import { ReactComponent as AllotmentIm } from "../../assets/Icons/Topbar/Residential/Allotment.svg";
import { ReactComponent as HostelIm } from "../../assets/Icons/Topbar/Residential/Hostel.svg";
import { ReactComponent as MealsIm } from "../../assets/Icons/Topbar/Residential/Meals.svg";
import { ReactComponent as TuitionIm } from "../../assets/Icons/Topbar/Residential/Tuition.svg";

import { ReactComponent as RevenueIm } from "../../assets/Icons/Topbar/Financial/Revenue.svg";
import { ReactComponent as ExpensesIm } from "../../assets/Icons/Topbar/Financial/Expenses.svg";
import { ReactComponent as LiabilitiesIm } from "../../assets/Icons/Topbar/Financial/Liabilities.svg";

import { ReactComponent as FeesIm } from "../../assets/Icons/Topbar/Financial/fees.svg";
import { ReactComponent as GrantsIm } from "../../assets/Icons/Topbar/Financial/grants.svg";
import { ReactComponent as OthersIm } from "../../assets/Icons/Topbar/Financial/others.svg";

import { ReactComponent as AcademicExIm } from "../../assets/Icons/Topbar/Financial/academicEx.svg";
import { ReactComponent as ResidentialExIm } from "../../assets/Icons/Topbar/Financial/residentialEx.svg";
import { ReactComponent as MarketingExIm } from "../../assets/Icons/Topbar/Financial/marketingEx.svg";
import { ReactComponent as CharityIm } from "../../assets/Icons/Topbar/Financial/charity.svg";
// setting routes topbar images
import { ReactComponent as SettingProfileIm } from "../../assets/Icons/Setting/NavigationIcons/Profile.svg";
import { ReactComponent as SettingPermissionIm } from "../../assets/Icons/Setting/NavigationIcons/Permission.svg";
import { ReactComponent as SettingAccissibilityIm } from "../../assets/Icons/Setting/NavigationIcons/Accissibility.svg";
import { ReactComponent as SettingPerferenceIm } from "../../assets/Icons/Setting/NavigationIcons/Perference.svg";
import { ReactComponent as SettingProductCubeIm } from "../../assets/Icons/Setting/NavigationIcons/Product-Cube.svg";

import AvatarIm from "../../assets/Images/avatar.png";
import { useLocation } from "react-router-dom";

const Topbar = () => {
  // eslint-disable-next-line
  const [toBarItems, setTopbarItems] = useState([
    {
      title: "Dashboard",
      parentPath: "management",
      href: "/organizational/management/dashboard",
      icon: <DashboardIm className="dashboardSvg" />,
    },
    {
      title: "Structure",
      parentPath: "management",
      href: "/organizational/management/structure",
      icon: <StructureIm className="structure" />,
    },
    {
      title: "Members",
      parentPath: "management",
      href: "/organizational/management/members",
      icon: <PersonGroupIm className="personGroupIcon" />,
    },
    {
      title: "Staffs",
      parentPath: "management",
      href: "/organizational/management/staffs",
      icon: <PersonGroupIm className="personGroupIcon" />,
    },
    {
      title: "Activites",
      parentPath: "management",
      href: "/organizational/management/activites",
      icon: <ActivitiesIm className="activity" />,
    },

    //operations(academics)
    {
      title: "Dashboard",
      parentPath: "academic",
      href: "operational/academic/dashboard",
      icon: <DashboardIm className="dashboardSvg" />,
    },
    {
      title: "Attendance",
      parentPath: "academic",
      href: "/operational/academic/attendence",
      icon: <AttendanceIm className="attendanceicon  fillSvg" />,
    },
    {
      title: "Students",
      parentPath: "academic",
      href: "/operational/academic/students",
      icon: <StudentsIm className="studentsSvg  fillActivePath" />,
    },
    {
      title: "Teachers",
      parentPath: "academic",
      href: "/operational/academic/teachers",
      icon: <TeachersIm className="teachersSvg fillActivePath" />,
    },
    {
      title: "Exams",
      parentPath: "academic",
      href: "/operational/academic/exams",
      icon: <ExamsIm className="examsSvg fillActivePath" />,
    },
    {
      title: "Programs",
      parentPath: "academic",
      href: "/operational/academic/programs",
      icon: <ProgramsIm className="fillActivePath" />,
    },
    {
      title: "Events",
      parentPath: "academic",
      href: "/operational/academic/events",
      icon: <EventsIm className="fillActivePath" />,
    },

    {
      title: "Admission",
      parentPath: "academic",
      href: "/operational/academic/admission",
      icon: <AdmissionIm className="fillActivePath" />,
    },
    // Residential topBar
    {
      title: "Dashboard",
      parentPath: "residential",
      href: "/operational/residential/dashboard",
      icon: <DashboardIm className="dashboardSvg" />,
    },
    {
      title: "Hostels",
      parentPath: "residential",
      href: "/operational/residential/hostels",
      icon: <HostelIm className="fillActivePath" />,
    },
    {
      title: "Allotment",
      parentPath: "residential",
      href: "/operational/residential/allotment",
      icon: <AllotmentIm className="fillActivePath" />,
    },
    {
      title: "Tuition",
      parentPath: "residential",
      href: "/operational/residential/tuition",
      icon: <TuitionIm className="fillSvg strokeActivePath" />,
    },
    {
      title: "Meals",
      parentPath: "residential",
      href: "/operational/residential/meals",
      icon: <MealsIm className="fillActivePath" />,
    },
    //Transportation routes items
    //workshop routes items
    {
      title: "Dashboard",
      parentPath: "workshop",
      href: "/operational/workshop/dashboard",
      icon: <DashboardIm className="dashboardSvg" />,
    },

    //financial Accountent routes
    {
      title: "Dashboard",
      parentPath: "accountent",
      href: "/finance/accountent/dashboard",
      icon: <DashboardIm className="dashboardSvg" />,
    },
    {
      title: "Revenue",
      parentPath: "accountent",
      href: "/finance/accountent/revenue",
      icon: <RevenueIm className="dashboardSvg" />,
    },
    {
      title: "Expenses",
      parentPath: "accountent",
      href: "/finance/accountent/expenses",
      icon: <ExpensesIm className="dashboardSvg" />,
    },
    {
      title: "Liabilities",
      parentPath: "accountent",
      href: "/finance/accountent/liabilities",
      icon: <LiabilitiesIm className="dashboardSvg" />,
    },
    //financial Cash InFlow routes
    {
      title: "Dashboard",
      parentPath: "cashinflow",
      href: "/finance/cashinflow/dashboard",
      icon: <DashboardIm className="dashboardSvg" />,
    },
    {
      title: "Fees",
      parentPath: "cashinflow",
      href: "/finance/cashinflow/fees",
      icon: <FeesIm className="dashboardSvg" />,
    },
    {
      title: "Grants",
      parentPath: "cashinflow",
      href: "/finance/cashinflow/grants",
      icon: <GrantsIm className="dashboardSvg" />,
    },
    {
      title: "Others",
      parentPath: "cashinflow",
      href: "/finance/cashinflow/others",
      icon: <OthersIm className="dashboardSvg" />,
    },
    //financial Cash OutFlow routes
    {
      title: "Dashboard",
      parentPath: "cashoutflow",
      href: "/finance/cashoutflow/dashboard",
      icon: <DashboardIm className="dashboardSvg" />,
    },
    {
      title: "Academic Ex.",
      parentPath: "cashoutflow",
      href: "/finance/cashoutflow/academicex",
      icon: <AcademicExIm className="dashboardSvg" />,
    },
    {
      title: "Residential Ex.",
      parentPath: "cashoutflow",
      href: "/finance/cashoutflow/residentialex",
      icon: <ResidentialExIm className="dashboardSvg" />,
    },
    {
      title: "Marketing Ex.",
      parentPath: "cashoutflow",
      href: "/finance/cashoutflow/marketingex",
      icon: <MarketingExIm className="dashboardSvg" />,
    },
    {
      title: "Charity",
      parentPath: "cashoutflow",
      href: "/finance/cashoutflow/charity",
      icon: <CharityIm className="dashboardSvg" />,
    },
    //Setting topbar routes
    {
      title: "Profile",
      parentPath: "setting",
      href: "/setting/profile",
      icon: <SettingProfileIm className="dashboardSvg" />,
    },
    {
      title: "Permission",
      parentPath: "setting",
      href: "/setting/permission",
      icon: <SettingPermissionIm className="dashboardSvg" />,
    },
    {
      title: "Accissibility",
      parentPath: "setting",
      href: "/setting/accissibility",
      icon: <SettingAccissibilityIm className="dashboardSvg" />,
    },
    {
      title: "Perference",
      parentPath: "setting",
      href: "/setting/perference",
      icon: <SettingPerferenceIm className="dashboardSvg" />,
    },
    {
      title: "Product Cube",
      parentPath: "setting",
      href: "/setting/ProductCube",
      icon: <SettingProductCubeIm className="dashboardSvg" />,
    },
  ]);
  const location = useLocation();
  const [parentPath, setParentPath] = useState("");
  console.log(parentPath);

  const topbarLinksSecRef = useRef(null);
  const navSubLinksRef = useRef(null);
  const [totalWidth, setTotalWidth] = useState(0);
  const [requiredWidth, setRequiredWidth] = useState(0); //this is calculated for add a btn to see the overflow cards
  useEffect(() => {
    let pathPart = location.pathname.split("/")[2]; // e.g., "cashinflow"
    if (location.pathname.split("/")[1] == "setting") {
      pathPart = location.pathname.split("/")[1];
    }

    setParentPath(pathPart);
  }, [location.pathname]);

  useEffect(() => {
    setTotalWidth(
      window
        .getComputedStyle(topbarLinksSecRef && topbarLinksSecRef.current)
        .width.split("px")[0] / 16
    );
  }, [topbarLinksSecRef]);

  useEffect(() => {
    // console.log(navSubLinksRef&&navSubLinksRef.current.children);
    let totalRequirement = 0;
    const length = navSubLinksRef && navSubLinksRef.current.children.length;
    for (let i = 0; i < length; i++) {
      // console.log(i)
      totalRequirement += Number(
        window
          .getComputedStyle(
            navSubLinksRef && navSubLinksRef.current.children[i]
          )
          .width.split("px")[0]
      );
    }
    setRequiredWidth(totalRequirement / 16); // in that case 16px=1rem
    // console.log(totalRequirement / 16, totalWidth);
  }, []);
  // console.log(location.state);

  return (
    <div className="topbar">
      <div className="topbarLinksSec" ref={topbarLinksSecRef}>
        <ul className="navSubLinks" ref={navSubLinksRef}>
          {/* Changes this code as it was interfering with the topBar while moving from one location to another */}
          {/*location &&
  location.state !== null &&
  toBarItems.map((data, index) => {
    if (parentPath === data.parentPath.toLowerCase()) {
      return (
        <NavItem
          key={index}
          title={data.title}
          path={data.href}
          icon={data.icon}
          activeBackground="#FFF6E8"
          activeFont="#FF9D00"
          style={{ width: "fit-content", padding: "0 1rem" }}
          state={data.parentPath}
        />
      );
    }
  })*/}

          {toBarItems.map((data, index) => {
            if (parentPath === data.parentPath.toLowerCase()) {
              return (
                <NavItem
                  key={index}
                  title={data.title}
                  path={data.href}
                  icon={data.icon}
                  activeBackground="#FFF6E8"
                  activeFont="#FF9D00"
                  style={{ width: "fit-content", padding: "0 1rem" }}
                  state={data.parentPath}
                />
              );
            }
          })}
        </ul>
      </div>
      <span
        style={{
          height: "74%",
          width: "2px",
          backgroundColor: "var(--borderGray)",
          borderRadius: "13px",
        }}
      ></span>
      <div className="topbarProfileSec">
        <img src={AvatarIm} alt="" />
        <div className="userProfileDetails">
          <h2>Aslam Khan</h2>
          <span>Admin</span>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
